import styled from 'styled-components';

const LeftColumn = styled.div`
  width: ${props => props.width || '35%'};
  height: inherit;
  outline: 0;
`;
export default styled(LeftColumn)``;
